import { DeviceIdService } from '@services/DeviceIdService';

export function useDeviceId(): string {
  return DeviceIdService.instance.id;
}
